import { configureStore } from '@reduxjs/toolkit';
import schemaReducer from './schemaReducer';
import responsibilityCenterReducer from './responsibilityCenterReducer';
import advancedSearchReducer from './advancedSearchReducer';
import { debugLog } from '../utils/debugLog';

export const store = configureStore({
    reducer: {
        schema: schemaReducer,
        responsibilityCenter: responsibilityCenterReducer,
        advancedSearch: advancedSearchReducer
    },
    devTools: {
        name: 'Hades SCIM Store',
        trace: true,
        traceLimit: 25
    }
});

// Log initial store state only when debug logging is enabled
if (process.env.NODE_ENV === 'development') {
    const initialState = store.getState();
    debugLog('🔧 Redux Store initialized with state:', initialState);
    debugLog('🔧 Redux Store slices:', Object.keys(initialState));
    debugLog('🔧 ResponsibilityCenter slice state:', initialState.responsibilityCenter);
    debugLog('🔧 ResponsibilityCenter slice exists?', 'responsibilityCenter' in initialState);
    debugLog('🔧 All reducer keys:', Object.keys(store.getState()));

    store.subscribe(() => {
        const state = store.getState();
        if (state.responsibilityCenter) {
            debugLog('🔧 ResponsibilityCenter state updated:', {
                cacheSize: state.responsibilityCenter.cache.length,
                loading: state.responsibilityCenter.loading,
                isLoaded: state.responsibilityCenter.isLoaded
            });
        }
    });
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

